export default __webpack_public_path__ + "static/media/rethinkdb.3f467744.svg";